import MultiQueryPageLoader from '@/app/common/components/MultiQueryPageLoader'
import { selectSelectedProgram } from '@/storage/programs/slice'
import { useSelector } from 'react-redux'

import ApprovalRulesDashboard from './components/payment-approval-dashboard'
import { useGetAllRules } from './hooks/useGetAllRules'
import getApprovalRulesConfig from './hooks/useGetApprovalRulesConfig'

import { usePagination } from '@/app/common/usePagination'
import useGetSystemCatalogCategories from '@/queries/system_catalog/hooks/useGetSystemCatalogCategories'
import { keepPreviousData } from '@tanstack/react-query'
import { useApprovalRuleFilters } from './hooks/useApprovalRuleFilters'

const DEFAULT_PER_PAGE = 20
function PaymentApprovalRulesPage() {
  const filters = useApprovalRuleFilters()
  const pagination = usePagination(DEFAULT_PER_PAGE)
  const programId = useSelector(selectSelectedProgram).id
  const categories = useGetSystemCatalogCategories()
  const approvalRulesConfigQuery = getApprovalRulesConfig()
  // this is a little awkward but it'll have to do for now.
  // Let's revisit better filtering logic later if possible
  function getIsActiveFilter(status: string) {
    if (status === 'All') return 'All'
    if (status === 'active') return 1

    return 0
  }

  const rulesQuery = useGetAllRules(
    {
      program_id: programId,
      records_per_page: pagination.perPage,
      page: pagination.currentPage,
      approval_type: filters.values.approvalType,
      target_type: filters.values.targetType,
      is_active: getIsActiveFilter(filters.values.status),
      rule_name: pagination.debouncedSearch,
    },
    {
      placeholderData: keepPreviousData,
    }
  )

  return (
    <MultiQueryPageLoader
      showLoadingOnlyOnFirstFetch={true}
      queries={
        [categories.query, rulesQuery, approvalRulesConfigQuery] as const
      }
    >
      {([categories, rules, approvalRulesConfig]) => {
        const rulesMetadata = rules?.meta

        return (
          <ApprovalRulesDashboard
            rules={rules.data}
            rulesMetadata={rulesMetadata}
            approvalRulesConfig={approvalRulesConfig}
            rulesIsLoading={rulesQuery.isFetching}
            categories={categories}
            filters={filters}
            pagination={pagination}
          />
        )
      }}
    </MultiQueryPageLoader>
  )
}

export default PaymentApprovalRulesPage
